export const getUsageResetCountdown = (resetsAt, now) => {
  const timestamp = typeof resetsAt === 'string' ? Date.parse(resetsAt) : NaN;
  if (!Number.isFinite(timestamp)) return { key: 'resetUnknown' };
  if (timestamp <= now) return { key: 'resetPending' };
  const minutes = Math.ceil((timestamp - now) / 60000);
  if (minutes >= 1440) {
    return { key: 'resetDays', days: Math.floor(minutes / 1440), hours: Math.floor((minutes % 1440) / 60) };
  }
  if (minutes >= 60) {
    return { key: 'resetHours', hours: Math.floor(minutes / 60), minutes: minutes % 60 };
  }
  return { key: 'resetMinutes', minutes };
};
